export const LOGS = [
  {
    key: 'status_history',
    table: 'requirement_status_history',
    label: 'Historial de Cambios de Status',
    singular: 'Cambio de Status',
    select:
      '*, requirement:requirements!requirement_id(reference_id), changed_by:users!changed_by_user_id(full_name), prev_status:status!previous_status_id(name, color), new_status:status!new_status_id(name, color)',
    orderBy: 'changed_at',
    orderAscending: false,
    columns: [
      { key: 'requirement.reference_id', label: 'Folio' },
      { key: 'status_field', label: 'Tipo', type: 'status_field_badge' },
      { key: 'changed_by.full_name', label: 'Cambiado por' },
      { key: 'prev_status', label: 'Status Anterior', type: 'status_badge' },
      { key: 'new_status', label: 'Nuevo Status', type: 'status_badge' },
      { key: 'changed_at', label: 'Fecha del Cambio', type: 'datetime' },
    ],
    searchKeys: [
      'requirement.reference_id',
      'changed_by.full_name',
      'prev_status.name',
      'new_status.name',
      'status_field',
    ],
  },
  {
    key: 'time_logs_audit',
    table: 'time_logs_audit',
    label: 'Auditoría de Registros de Tiempo',
    singular: 'Registro de Auditoría',
    select: '*',
    orderBy: 'changed_at',
    orderAscending: false,
    needsUserLookup: true,
    columns: [
      { key: 'time_log_id', label: 'ID Registro' },
      { key: 'action', label: 'Acción', type: 'action_badge' },
      { key: 'changed_by_user_id', label: 'Cambiado por', type: 'user_lookup' },
      { key: 'changed_at', label: 'Fecha del Cambio', type: 'datetime' },
    ],
    searchKeys: ['time_log_id', 'action', '_user_name'],
    hasDetailView: true,
    actionFilterOptions: [
      { value: '', label: 'Todas las acciones' },
      { value: 'INSERT', label: 'Creación' },
      { value: 'UPDATE', label: 'Edición' },
      { value: 'DELETE', label: 'Eliminación' },
    ],
  },
  {
    key: 'requirement_comments_audit',
    table: 'requirement_comments_audit',
    label: 'Auditoría de Comentarios en Requerimientos',
    singular: 'Cambio de Comentario',
    select: '*',
    orderBy: 'changed_at',
    orderAscending: false,
    needsUserLookup: true,
    columns: [
      { key: 'reference_id', label: 'Folio' },
      { key: 'action', label: 'Acción', type: 'action_badge' },
      { key: 'old_comment', label: 'Comentario Anterior', type: 'comment_text' },
      { key: 'new_comment', label: 'Nuevo Comentario', type: 'comment_text' },
      { key: 'changed_by_user_id', label: 'Cambiado por', type: 'user_lookup' },
      { key: 'changed_at', label: 'Fecha del Cambio', type: 'datetime' },
    ],
    searchKeys: ['reference_id', '_user_name', 'old_comment', 'new_comment'],
    actionFilterOptions: [
      { value: '', label: 'Todas las acciones' },
      { value: 'CREATE', label: 'Creación' },
      { value: 'UPDATE', label: 'Edición' },
      { value: 'DELETE', label: 'Eliminación' },
    ],
  },
  {
    key: 'requirement_devs_audit',
    table: 'requirement_devs_audit',
    label: 'Historial de Asignación de Desarrolladores',
    singular: 'Asignación de Desarrollador',
    select: '*',
    orderBy: 'changed_at',
    orderAscending: false,
    needsUserLookup: true,
    columns: [
      { key: 'reference_id', label: 'Folio' },
      { key: 'action', label: 'Acción', type: 'action_badge' },
      { key: 'previous_dev_ids', label: 'Desarrolladores Anteriores', type: 'dev_snapshot' },
      { key: 'new_dev_ids', label: 'Desarrolladores Nuevos', type: 'dev_snapshot' },
      { key: 'changed_by_user_id', label: 'Cambiado por', type: 'user_lookup' },
      { key: 'changed_at', label: 'Fecha del Cambio', type: 'datetime' },
    ],
    searchKeys: ['reference_id', '_user_name', '_dev_names'],
    actionFilterOptions: [
      { value: '', label: 'Todas las acciones' },
      { value: 'ASSIGN', label: 'Asignación' },
      { value: 'UNASSIGN', label: 'Desasignación' },
    ],
  },
];
